const DLM_APPLICATION_TYPES = {
  TYPE_APPLICATION: 'Application',
  TYPE_SITEINSPECTION: 'Site Inspection',
  TYPE_LABELREPLACEMENT: 'Label Replacement',
  TYPE_LABELINSPECTION: 'Label Inspection',
  TYPE_EDIT: 'Label Edit',
  TYPE_SPLIT: 'Label Split',
  TYPE_TRIGGERTEST: 'Trigger Test',
  TYPE_DOCEDIT: "DOC Edit",
  TYPE_DOCSPLIT: "DOC Split",
  TYPE_DOCINCREASE: "DOC Increase",
  TYPE_ROIEDIT: "ROI Edit",
  TYPE_ROISPLIT: "ROI Split"
}

const DLM_TYPES = {
  TYPE_DOC: "DOC",
  TYPE_LABEL: "Label"
};

const DLM_DOC_WORKFLOWS = {
  WORKFLOW_DOC : 'DOC',
  WORKFLOW_DOC1B : 'DOC Batch Testing',    
};

const DLM_LABEL_WORKFLOWS = {
  WORKFLOW_LABEL5 : 'Scheme 5',
  WORKFLOW_LABEL1B1 : 'Scheme 1b 1 Loop',
  WORKFLOW_LABEL1B2 : 'Scheme 1b 2 Loop',
  WORKFLOW_LABEL1B3 : 'Scheme 1b 3 Loop',
};

const DLM_INSPECTION_MODES = {
  TYPE_SITEINSPECTION: 'Site Inspection',
  TYPE_TRIGGERTEST: 'Trigger Test',
  TYPE_LABELINSPECTION: 'Label Inspection'
}

const DLM_INSPECTION_TYPES = {
  ITYPE_BYTYPE: 'By Company',
  ITYPE_BYCERT: 'By Certificate'
}

const DLM_LABEL_WORKFLOW_CODES = [
  'Label1b1',
  'Label1b2',
  'Label1b3',
  'Label5',
];

const DLM_END_STATES = [
  'Completed',
  'Failed',
  'Terminated',
  'Withdrawn',
  'TERMINATED',
  'COMPLETED',
  'FAILED',
  'WITHDRAWN'
];

const DLM_NO_TERMINATE_STATES = [
  'Applicant Confirmation',
  'Applicant Sign',
  'Applicant Signed',
];

const DLM_TYPE5_NO_TERMINATE_STATES = [
  'Applicant Confirmation',
  'Applicant Sign',
  'Applicant Signed',
  'Pending Inspection',
  'Inspection Setup',
  'Site Inspection',
  'Site Inspection - Issue',
  'Site Inspection Review',
];

const DLM_USER_RESPOND_STATES = [
  'Admin Review',    
  'Applicant Signed',    
  'DOC Pending SCDF Verification',
  'Inspection Setup',
  'Pending Component Check',
  'Program Manager Approval',
  'Program Manager Approval - Admin Setup',
  'Program Manager Approved',
  'Program Manager Rejected',
  'Program Manager Rejected (A)',
  'ROI Pending SCDF Verification',
  'Schedule For Sampling',
  'Site Inspection',
  'Site Inspection Approved',
  'Site Inspection Review',
  'Testing in Progress',
  'Component Check - Admin Setup',
  'Batch Testing',
  'Batch Testing Setup',
  'Sampling',
  'Sampling Setup',
  'Testing',
  'Testing Setup',
  'Site Inspection Setup',  
  'Draft Quotation',
  'Quotation Approved',

];


const DLM_USER_NON_VERDICT_STATES = [
  'Schedule For Sampling',
  'Inspector Reviewer',
  'Program Manager Approved',
  'Site Inspection Approved',
  'Program Manager Approval - Admin Setup',
  'Inspection Setup',
  'DOC Pending SCDF Verification',
  'ROI Pending SCDF Verification',
  'Component Check - Admin Setup',    
  'Batch Testing Setup',
  'Sampling Setup',
  'Testing Setup',
  'Site Inspection Setup',
  'Draft Quotation',
];


const DLM_APPLICANT_RESPOND_STATES = [
  'Site Inspection - Issue',
  'Program Manager Approval - Issue',
  'Applicant Confirmation',
  'Pending Inspection',
  'Component Check Issue',
  'Component Check - Issue',
  'Pending Re-Component Check',
  'Applicant Sign',
  'Batch Testing - Issue',
  'Sampling - Issue',
  'Testing - Issue',
  'Pending Batch Testing',
  'Pending Sampling',
  'Pending Testing', 
  'Site Inspection - Issue', 
  'Quotation Pending Approval',
];

const DLM_USER_INSPECTION_RESPOND_STATES = [
  'Site Labelling Setup',
  'Site Labelling',
  'Site Labelling Approved',
  'Applicant Signed',
  'ROI Pending SCDF Verification'
];

const DLM_APPLICANT_INSPECTION_RESPOND_STATES = [
  'Pending Site Labelling',
  'Site Labelling - Issue',
  'Applicant Sign',
  'Applicant Confirmation',
  'Pending Re-Site Labelling',
];

const DOC_MODEL_FIELDS = [
  'docId',
  'docAttachmentId',
  'siteApplicationId',
  'inspectionId',
  'issueDate',
  'cbRef',
  'companyName',
  'installer',
  'projectName',
  'planNo',
  'otherRef',
  'productType',
  'cocNo',
  'brand',
  'model',
  'areaOfCoverage',  
  'unit',
  'hourRating',
  'location',
  'draftDOCFile',
  'signedDOCFile',
];

const DOC_MODEL_CHECK_FIELDS = [
  'companyName',
  'installer',
  'projectName',
  'productType',
  'brand',
  'model',
];


const DLM_ROI_GENERATE_FIELDS = [
  'id',
  'roiId',
  'roiAttachmentId',
  'inspectionId',
  'siteApplicationId',
  'cocHolderRef',
  'cocHolder',
  'cocHolderAddress',
  'installerCompany',
  'cocNo',
  'brand',
  'model',
  'country',
  'projectName',
  'planNo',
  'series',
  'otherRef',
  'type',
  'no',
  'quantity',
  'serial',
  'revision',
  'split',
  'roiDetails',
  'cbRef',
  'issueDate'
];

const DLM_ROIDETAIL_FIELDS = [
  "id",
  "itemNo",
  "size",
  "hourRating",
  "labelFrom",
  "labelTo",
  "model",
  "type",
  "quantity",
  "remarks"
];

const DLM_ROI_FILE_FIELDS = [
  'draftROIFile',
  'actualROIFile',
  'signedROIFile'
];


const DLM_USER_REASSIGN_APP_STATES = [    
  { state : 'Admin Review', role : 'DLM Admin'},
  { state : 'Applicant Signed', role : 'DLM Admin'},
  { state : 'Component Check Setup', role : 'DLM Admin'},
  { state : 'DOC Pending SCDF Verification', role : 'DLM Admin'},
  { state : 'Inspection Setup', role : 'DLM Admin'},
  { state : 'Inspector Reviewer', role : 'DLM Inspector'},
  { state : 'Pending Component Check', role : 'DLM Inspector'},
  { state : 'Program Manager Approval - Admin Setup', role : 'DLM Admin'},
  { state : 'Program Manager Approval', role : 'DLM Program Manager'},
  { state : 'Program Manager Approved', role : 'DLM Admin'},
  { state : 'Program Manager Rejected', role : 'DLM Admin'},
  { state : 'Program Manager Rejected (A)', role : 'DLM Admin'},
  { state : 'ROI Pending SCDF Verification', role : 'DLM Admin'},
  { state : 'Schedule For Sampling', role : 'DLM Admin'},
  { state : 'Site Inspection Approved', role : 'DLM Admin'},
  { state : 'Site Inspection Review', role : 'DLM Inspector'},
  { state : 'Site Inspection', role : 'DLM Inspector'},
  { state : 'Batch Testing', role : 'DLM Inspector'},    
  { state : 'Testing', role : 'DLM Inspector'},    
  { state : 'Sampling', role : 'DLM Inspector'},    
  { state : 'Testing in Progress', role : 'DLM Inspector'},    
  { state : 'Draft Quotation', role : 'CAMS Quotation Admin'},
  { state : 'Quotation Approved', role : 'CAMS Quotation Admin'},
];

const DLM_APPLICATION_NOEDIT_STATES = [
  'Draft',
  'DRAFT',
  'Admin Review - Issue',
  "DOC Pending SCDF Verification",
  "ROI Pending SCDF Verification",
  "Applicant Confirmation",  
  "Applicant Sign",
  "Applicant Signed",
  'Completed',
  'Failed',
  'Terminated',
  'Withdrawn',
  'TERMINATED',
  'COMPLETED',
  'FAILED',
  'WITHDRAWN'
];


const DLMApplicationTerminationStates = {
  REQUEST_TERMINATE_APPLICATION : {
    code: 'Request',
    state: 'Application Termination Requested',
    icon: '/media/icons/duotune/arrows/arr076.svg'
  },
  REQUEST_TERMINATE_APPLICATION_REPLY : {
    code: 'Replied',
    state: 'Application Termination RFI',
    icon: '/media/icons/duotune/communication/com007.svg'
  },
  COMPLETED : {
    code: 'Completed',
    state: 'Application Termination Completed',
    icon: '/media/icons/duotune/arrows/arr061.svg' // X box  // '/media/icons/duotune/arrows/arr085.svg' // check box
  },
  FAILED : {
    code: 'Failed',
    state: 'Application Termination Failed',
    icon: null,     // '/media/icons/duotune/arrows/arr061.svg'
  },
}


const DLMApplicationEditStates = {
  REQUEST_EDIT_APPLICATION : {
    code: 'Request',
    state: 'Application Edit Requested',
    icon: '/media/icons/duotune/general/gen055.svg'        
  },
  REQUEST_EDIT_APPLICATION_REPLY : {
    code: 'Replied',
    state: 'Application Edit RFI',
    icon: '/media/icons/duotune/communication/com007.svg'        
  },    
  COMPLETED : {
    code: 'Completed',
    state: 'Application Edit Completed',
    icon: '/media/icons/duotune/arrows/arr061.svg'   // X box   //  '/media/icons/duotune/arrows/arr085.svg' // check mark
  },    
  FAILED : {
    code: 'Failed',
    state: 'Application Edit Failed',
    icon: null, 
  },    
}


export type LeafDoorType = 'UDL' | 'EDL' | 'SL' | null;


const LEAF_TYPE_OPTIONS = [
  {value: 'EDL', text: 'EDL'},
  {value: 'UDL', text: 'UDL'},
  {value: 'SL', text: 'SL'}
];


export {
  DLM_APPLICATION_TYPES,
  DLM_TYPES, 
  DLM_DOC_WORKFLOWS, DLM_LABEL_WORKFLOWS, DLM_LABEL_WORKFLOW_CODES,
  DLM_INSPECTION_MODES, DLM_INSPECTION_TYPES, DLM_END_STATES,
  DLM_USER_RESPOND_STATES, DLM_USER_INSPECTION_RESPOND_STATES,
  DLM_APPLICANT_RESPOND_STATES, DLM_APPLICANT_INSPECTION_RESPOND_STATES,
  DOC_MODEL_FIELDS, DOC_MODEL_CHECK_FIELDS,
  DLM_ROI_GENERATE_FIELDS, DLM_ROIDETAIL_FIELDS, DLM_ROI_FILE_FIELDS,
  DLMApplicationTerminationStates,
  DLM_NO_TERMINATE_STATES,
  DLM_TYPE5_NO_TERMINATE_STATES,
  DLM_USER_NON_VERDICT_STATES,    
  DLM_USER_REASSIGN_APP_STATES,
  LEAF_TYPE_OPTIONS,
  DLMApplicationEditStates, DLM_APPLICATION_NOEDIT_STATES,
}   